<template>
    <div>
        <div class="mb-3 text-right">
            <hts-form-button
                v-if="checkPermission(layoutPermissions['costing_assumption_add'])"
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="openAddAssumptionCosting">
                {{ $t('labels.add') }}
            </hts-form-button>
        </div>
        <hts-data-table
            ref="dataTables"
            :headers="assumptionCostingHeaders"
            :server="apiListAssumption" />
        <add-assumption-costing
            ref="addAssumptionCosting"
            @refreshTables="refreshTables" />
        <edit-assumption-costing
            ref="editAssumptionCosting"
            @refreshTables="refreshTables" />
        <hts-modal
            :show="showPopupDeleteAssumption"
            :title="$t('labels.deleteAssumptionCosting')"
            type="confirm"
            :content="$t('labels.confirmDeleteAssumptionCosting')"
            @hide="closePopupDeleteAllowancesIncurred"
            @confirm="handleDeleteAssumptionCosting" />
    </div>
</template>

<script setup lang="ts">
import AddAssumptionCosting from './-component/assumption/add.vue'
import EditAssumptionCosting from './-component/assumption/edit.vue'
import actions from './-component/tables/actions.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'
import { CostingAssumption } from '~/pages/trucker-[id]/cost/-component/imports/form'

const { $formatters } = useNuxtApp()

const apiListAssumption = $url.cost.assumption.assumptionList

const addAssumptionCosting: any = ref(null)
const openAddAssumptionCosting = () => {
  if (addAssumptionCosting.value) {
    addAssumptionCosting.value.open()
  }
}

const editAssumptionCosting: any = ref(null)
const openEditAssumptionCosting = (data: CostingAssumption) => {
  if (editAssumptionCosting.value) {
    editAssumptionCosting.value.open(data._id)
  }
}

const assumptionCostingId = ref('')

const showPopupDeleteAssumption = ref(false)
const openDeleteAssumptionCosting = (data: CostingAssumption) => {
  assumptionCostingId.value = data?._id
  showPopupDeleteAssumption.value = true
}
const closePopupDeleteAllowancesIncurred = () => {
  showPopupDeleteAssumption.value = false
  assumptionCostingId.value = ''
}
const handleDeleteAssumptionCosting = () => {
  const api = $url.cost.assumption.deleteAssumption
  $api(api, { uriParams: { ID: assumptionCostingId.value } })
    .then((data: any) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        process.client && $toast().success($t('labels.deleteAssumptionCostingSuccess'))
        assumptionCostingId.value = ''
      }
      refreshTables()
      showPopupDeleteAssumption.value = false
    })
    .catch(() => {
      showPopupDeleteAssumption.value = false
      assumptionCostingId.value = ''
    })
}

const assumptionCostingHeaders = ref([
  {
    field: 'name',
    headerName: $t('labels.cost'),
    sortable: true,
    valueGetter: (params: any) => {
      if (params.data.name === 'ASSUMPTION_GASOLINE') {
        return $t('labels.assumptionGasoline')
      }
      return ''
    }
  },
  {
    field: 'indicator',
    headerName: $t('labels.indicator'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.formatCurrency(params.data.indicator)
    }
  },
  {
    field: 'categoryVehicleName',
    headerName: $t('labels.vehicleType')
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    popup: true,
    suppressRowTransform: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: actions,
    cellRendererParams: {
      items: [
        {
          icon: 'hi-pencil-square-icon',
          label: $t('labels.edit'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.costing_assumption_edit),
          click: openEditAssumptionCosting
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: checkPermission(layoutPermissions.costing_assumption_delete),
          click: openDeleteAssumptionCosting
        }
      ]
    }
  }
])

const dataTables = ref()

const refreshTables = () => {
  if (dataTables.value) {
    dataTables.value.refresh()
  }
}
</script>
